export default __webpack_public_path__ + "static/careers-our-values-aa59cfd7241e521a7bbabe9a7fc992be.svg";